export const enum VALIDATION {
  REQUIRED = "RequiredFiled",
  EMAIL = "EmailInvalid",
  PHONE = "PhoneInvalid",
}
